import { render, staticRenderFns } from "./HouseManage.vue?vue&type=template&id=2ed739b0&scoped=true&"
import script from "./HouseManage.vue?vue&type=script&lang=js&"
export * from "./HouseManage.vue?vue&type=script&lang=js&"
import style0 from "./HouseManage.vue?vue&type=style&index=0&id=2ed739b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed739b0",
  null
  
)

export default component.exports